export default __webpack_public_path__ + "static/media/pricetag.92a013d3.svg";